import { render, staticRenderFns } from "./RadioCards.vue?vue&type=template&id=237b8153"
import script from "./RadioCards.vue?vue&type=script&lang=js"
export * from "./RadioCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports